window.User = {
  init: function() {}
};

$(document).ready(function() {
  return User.init();
});
